import Alpine from "alpinejs"
import { kgToLbs, lbsToKg, round } from "../dataStore"

export default (getView) => (nextStepPath) => ({
  ...getView(nextStepPath),

  formValues: {
    weightKg: null,
    weightLbs: null,
  },

  onInit() {
    Alpine.effect(() => {
      if (this.store.isMetric) {
        this.formValues.weightLbs = round(kgToLbs(this.formValues.weightKg)) || 0
      } else {
        this.formValues.weightKg = round(lbsToKg(this.formValues.weightLbs)) || 0
      }
    })
  },

  processFormValues() {
    if (this.store.isMetric) {
      return {
        weightKg: parseInt(this.formValues.weightKg),
        weightLbs: round(kgToLbs(this.formValues.weightKg)),
      }
    } else {
      return {
        weightKg: round(lbsToKg(this.formValues.weightLbs)),
        weightLbs: parseInt(this.formValues.weightLbs),
      }
    }
  },
})
